import { getString } from "../../../common/common";

export const SEARCH_BY = "SEARCH_BY";
export const PNR_TICKET_NO = "PNR_TICKET_NO";
export const TRIP_CODE = "TRIP_CODE";
export const ENTER_PNR_NUMBRE = "ENTER_PNR_NUMBRE";
export const TRIP_SHEET_STATUS = "TRIP_SHEET_STATUS";
export const VEHICLE_NUMBER = "VEHICLE_NUMBER";
export const CREW_CONTACT_NO = "CREW_CONTACT_NO";
export const SERVICE_STATUS = "SERVICE_STATUS";
export const BOARDING_POINT = "BOARDING_POINT";
export const BOARDING_TIME = "BOARDING_TIME";

export const DEPARTURE_DATE = "DEPARTURE_DATE";
export const ENTER_TCNDD = "ENTER_TCNDD";

export const translations = {
  en: {
    [SEARCH_BY]: "Search By",
    [PNR_TICKET_NO]: "PNR-Ticket No.",
    [TRIP_CODE]: "Trip Code",
    [ENTER_PNR_NUMBRE]: "Enter PNR Number",
    [TRIP_SHEET_STATUS]: "Trip Sheet Generated Status",
    [VEHICLE_NUMBER]: "Vehicle Number",
    [CREW_CONTACT_NO]: "Crew Contact No",
    [SERVICE_STATUS]: "Service Status",
    [BOARDING_POINT]: "Boarding Point",
    [BOARDING_TIME]: "Boarding Time",
    [DEPARTURE_DATE]: "Departure Date",
    [ENTER_TCNDD]: "Enter Tripcode and Departure Date",
  },
  kn: {
    [SEARCH_BY]: "ಇವರಿಂದ ಹುಡುಕಿ",
    [PNR_TICKET_NO]: "PNR-ಟಿಕೆಟ್ ನಂಬರ್.",
    [TRIP_CODE]: "ಟ್ರಿಪ್ ಕೋಡ್",
    [ENTER_PNR_NUMBRE]: "PNR ನಂಬರ್ ಅನ್ನು ಎಂಟರ್ ಮಾಡಿ",
    [TRIP_SHEET_STATUS]: "ಟ್ರಿಪ್ ಶೀಟ್ ಜೆನೆರೇಟ್ ಆದ  ಸ್ಥಿತಿ",
    [VEHICLE_NUMBER]: "ವಾಹನ ಸಂಖ್ಯೆ",
    [CREW_CONTACT_NO]: "ಸಿಬ್ಬಂದಿ ಸಂಪರ್ಕ ಸಂಖ್ಯೆ",
    [SERVICE_STATUS]: "ಸೇವೆಯ ಸ್ಥಿತಿ",
    [BOARDING_POINT]: "ಹತ್ತುವ ಸ್ಥಳಗಳು",
    [BOARDING_TIME]: "ಬೋರ್ಡಿಂಗ್ ಸಮಯ",
    [DEPARTURE_DATE]: "ನಿರ್ಗಮನ ದಿನಾಂಕ",
    [ENTER_TCNDD]: "ಟ್ರಿಪ್‌ಕೋಡ್ ಮತ್ತು ಹೊರಡುವ ದಿನಾಂಕವನ್ನು ಎಂಟರ್ ಮಾಡಿ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
